import React from "react";
import Fade from "react-reveal/Fade";
import parse from "html-react-parser";

import "./_thinking-block.scss";

const LifeSymphony = ({ home: { home } }) => (
  <>
    {home && home.info_section_3 && (
      <div className="thinking-block thinking-block-reverse pt-md-5">
        <div className="container">
          <Fade right>
            <div className="left">
              <div className="img">
                <div className="certificate">
                  <img src={home.info_section_3.image_2} alt="" />
                </div>
                <img src={home.info_section_3.image} className="image" alt="" />
              </div>
            </div>
          </Fade>
          <Fade left>
            <div className="right">
              <div className="block">
                <h2 className="h3 text-white">
                  {home.info_section_3.section_title}
                </h2>
                <p>{parse(home.info_section_3.description)}</p>
                <div className="cta">
                  <a
                    href={home.info_section_3.link}
                    className="btn btn-link text-white"
                  >
                    Explore Opportunities
                  </a>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    )}
  </>
);

export default LifeSymphony;
